<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            groupList: filteredGroups$ | async,
            disabled: disabled.$ | async,
            values: values.$ | async,
        } as data"
    >
        <ng-container *ngIf="ngControl.control; let control">
            <div
                [class]="'bazis-control bazis-control_autocomplete ' + cssClassSizeControl"
                [ngClass]="{
                    'bazis-control--focused': isFocused,
                    'bazis-control--activated': showList,
                    'bazis-control--dirty': ngControl.control.dirty,
                    'bazis-control--empty':
                        emptyValues.indexOf(ngControl.control.value) > -1 ||
                        (multiple && !ngControl.control.value?.length),
                    'bazis-control--invalid': control.invalid,
                    'bazis-control--disabled': data.disabled,
                }"
                clickOutside
                (clickOutside)="hideList()"
            >
                <bazis-label
                    [id]="attrId"
                    [isMajor]="hasTitleMajor"
                    [isEmptyLabel]="isEmptyLabel"
                    [title]="title || t(titleKey, titleParams)"
                    [required]="data.required"
                >
                    <bazis-interrogation
                        *ngIf="tooltipKey"
                        [slot]="tooltipSettings?.targetSide"
                        iconSize="compact"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipOffset]="[-8, 4]"
                        [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                        [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                        [icon]="icons.interrogation"
                        [type]="interrogationType"
                    ></bazis-interrogation>
                </bazis-label>

                <div
                    class="bazis-control__field-group"
                    [class.bazis-control__field-group--activated]="showList"
                    [class.bazis-control__field-group--disabled]="data.disabled"
                >
                    <bazis-control-field-start
                        [isClickable]="isLeftIconClickable"
                        [icon]="leftIcon"
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        (actionClick)="onLeftIconClick($event)"
                    >
                    </bazis-control-field-start>

                    <div class="bazis-control__field">
                        <!-- Прекрасный кастомный селект -->
                        <div
                            class="bazis-select"
                            [class.bazis-select_secondary]="type === 'secondary'"
                            aria-hidden="true"
                        >
                            <ng-container *ngIf="selectedValues$ | async as selectedValues">
                                <div
                                    *ngIf="!showList && !isFocused"
                                    class="bazis-select__trigger"
                                    [class.bazis-select__trigger_noempty]="selectedValues.length"
                                    (click)="toggleList()"
                                >
                                    <span *ngIf="selectedValues.length; else tplNotSelectedOptions">
                                        <ng-container
                                            *ngFor="let selected of selectedValues; let i = index"
                                        >
                                            <bazis-item-with-icon-value
                                                [item]="selected"
                                            ></bazis-item-with-icon-value>
                                            {{ i < selectedValues.length - 1 ? ',' : '' }}
                                        </ng-container>
                                    </span>
                                    <ng-template #tplNotSelectedOptions>
                                        <span
                                            *ngIf="optionLabel"
                                            class="bazis-text_placeholder"
                                        >
                                            {{ t(optionLabel) }}
                                        </span>
                                    </ng-template>
                                </div>
                            </ng-container>
                            <input
                                #searchInput
                                class="bazis-control__field"
                                [formControl]="searchControl"
                                (focus)="isFocused = true; showList = true"
                                (blur)="onBlurInput()"
                            />
                        </div>
                    </div>

                    <!-- <bazis-control-select-end
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        [iconUp]="iconUp"
                        [iconDown]="iconDown"
                        [showList]="showList"
                        (toggled)="toggleList()"
                    >
                    </bazis-control-select-end> -->

                    <bazis-control-search-end
                        [tooltipText]="t(tooltipKey, tooltipParams)"
                        [tooltipSettings]="tooltipSettings"
                        [multiple]="multiple"
                        [isDisabled]="data.disabled"
                        [canEraserShow]="hasEraser"
                        [searchValue]="searchControl.value"
                        [controlValue]="control.value"
                        [iconUp]="iconUp"
                        [iconDown]="iconDown"
                        [showList]="showList"
                        (erased)="onClear()"
                        (toggled)="toggleList()"
                    ></bazis-control-search-end>

                    <div
                        class="bazis-list bazis-list_control-dd"
                        [hidden]="!showList"
                    >
                        <div
                            *ngFor="let group of data.groupList; let i = index"
                            [class.bh-inline-block]="isOneline"
                            class="bazis-item bazis-item_group"
                        >
                            <span
                                *ngIf="group.groupEntity as groupEntity"
                                (click)="toggleGroup(i)"
                            >
                                {{ groupEntity.$snapshot.name }}
                                <bazis-icon
                                    size="regular"
                                    [name]="showGroup[i] ? icons.angleUp : icons.angleDown"
                                ></bazis-icon>
                            </span>
                            <div
                                [hidden]="!showGroup[i]"
                                class="bazis-list"
                            >
                                <bazis-multiple-selection-option
                                    *ngFor="let option of group.groupOptions"
                                    [option]="option"
                                    [byCheckbox]="byCheckbox"
                                    [multiple]="multiple"
                                    [values]="data.values"
                                    (toggled)="toggleValue(option.id)"
                                ></bazis-multiple-selection-option>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bazis-control__error">
                    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
                </div>

                <div
                    *ngIf="noteKey"
                    class="bazis-control__note"
                >
                    {{ noteKey }}
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
